import React from "react";
import { Typography, Box, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const SuccessMessage = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#f9f9f9",
        textAlign: "center",
        padding: "20px",
      }}
    >
      <Stack
        alignSelf={"center"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <img
          src="https://meatheadmovers.com/wp-content/uploads/2024/03/desktoplogo.png"
          width={280}
          alt="Logo"
        />
      </Stack>
      <Typography
        variant="h4"
        sx={{
          color: "#000000",
          fontWeight: 600,
          marginBottom: 2,
        }}
      >
        Thank you for uploading images!
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "#555",
          marginBottom: 1,
        }}
      >
        Your images have been successfully uploaded.
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "#555",
          marginBottom: 4,
        }}
      >
        Meathead Movers will be reaching back out soon
      </Typography>
    </Box>
  );
};

export default SuccessMessage;
